import * as React from "react";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import * as cls from "./modalNotifications.module.scss";
import {
  currentNotificationIndexAction,
  lssBlockNotificationDataAction,
  notificationsSummariesAction,
  showElectronicConsentsDetailAction,
} from "../../redux/actions/actions";
import ModalAttestationTheme from "../modalAttestationTheme/ModalAttestationTheme";
import { StudentService } from "../studentService";
import { ErrataViewInfo } from "../../../personal-studio-components/service/ErrataViewInfo";
import { ErrataView } from "../../../personal-studio-components/service";
import { Button } from "../../../personal-studio-components/form";
export default function ModalElectronicConsepts() {
  const [errorMessage, setErrorMessage] = useState("");

  const theme = useTheme();
  const dispatch = useDispatch();

  const handleClose = () => {
    dispatch(currentNotificationIndexAction());
    dispatch(showElectronicConsentsDetailAction(false));
  };

  const { currentNotificationData } = useSelector(
    (state) => state.notifications
  );

  const [data, setData] = useState(null);

  const { access_token } = useSelector((state) => state.token);
  const { contractId } = useSelector((state) => state.contract);
  const { openElectronicConsents } = useSelector(
    (state) => state.notifications
  );
  async function getDetail() {
    const request = {
      method: "post",
      path: "/student/notification/get",
      data: {
        access_token,
        study_contract_id: contractId,
        planning_event_id: currentNotificationData?.planning_event_id,
      },
    };
    const data = await StudentService.send(request, (response) => {});
    if (!data.errors) {
      setData({ ...data, is_event_actual: true, LSSBlocking: false });
    } else if (data.error_type !== "auth") {
      setErrorMessage(data);
    } else {
      const errorEvent = new ErrorEvent("error", {
        error: data,
      });
      window.dispatchEvent(errorEvent);
      return;
    }
  }

  useEffect(() => {
    if (
      access_token &&
      contractId &&
      currentNotificationData?.planning_event_id
    ) {
      getDetail();
    }
  }, [access_token, contractId, currentNotificationData?.planning_event_id]);

  const renderTextWithComponents = (text) => {
    const parts = text.split("@@AttestationTheme@@");
    return parts.map((part, index) => (
      <div>
        <p dangerouslySetInnerHTML={{ __html: part }}></p>
        {index < parts.length - 1 && <ModalAttestationTheme />}
      </div>
    ));
  };

  useEffect(() => {
    if (data?.EventTypeID === 16000) {
      const transformedText = renderTextWithComponents(data.text);
      setData((prev) => {
        return { ...prev, text: transformedText };
      });
    }
  }, [data?.EventTypeID]);
  useEffect(() => {
    window.Notificationchoice = () => {};
  }, []);
  if (errorMessage) {
    return (
      <Dialog
        open={openElectronicConsents}
        aria-labelledby="responsive-dialog-title"
        classes={{ paper: cls.dialog_paper }}
        disableEscapeKeyDown
        hideBackdrop
        style={{ backgroundColor: "rgba(155,155,155,.63)" }}
      >
        {errorMessage.error_type === "info" ? (
          <ErrataViewInfo errata={errorMessage} />
        ) : (
          <ErrataView errata={errorMessage} />
        )}
      </Dialog>
    );
  }
  if (data)
    return (
      <Dialog
        open={openElectronicConsents}
        aria-labelledby="responsive-dialog-title"
        classes={{ paper: cls.dialog_paper }}
        disableEscapeKeyDown
        hideBackdrop
        style={{ backgroundColor: "rgba(155,155,155,.63)" }}
      >
        <DialogTitle
          sx={{ margin: "0 0 1.875rem 0 !important", padding: "0" }}
          id="responsive-dialog-title"
        >
          {new Date(data.sys_creation_date).toLocaleDateString()}
        </DialogTitle>
        <DialogTitle
          sx={{ margin: "0 0 1.875rem 0 !important", padding: "0" }}
          id="responsive-dialog-title"
        >
          {data.header}
        </DialogTitle>
        <DialogContent>
          {/* <DialogContentText> */}
          {data?.EventTypeID === 16000 ? (
            <div className={cls.contentText}>{data.agreement_text}</div>
          ) : (
            <div>
              <p
                className={cls.contentText}
                dangerouslySetInnerHTML={{ __html: data.agreement_text }}
              ></p>
            </div>
          )}
          {/* </DialogContentText> */}
        </DialogContent>
        <div className={cls.dialogActions}>
          <div className={cls.notificationCheckbox}>
            <input
              checked={true}
              type="checkbox"
              className={cls.input}
              disabled={true}
            />
            <p className={cls.agreement}>Прочитано, выражаю согласие</p>
          </div>
          <div>
            <DialogActions classes={{ paper: cls.dialogContnent }}>
              {/* <Button disabled>Подтвердить</Button> */}
              <Button disabled>Подтвердить</Button>
              <Button onClick={handleClose} type="primary">
                Закрыть
              </Button>
            </DialogActions>
          </div>
        </div>
      </Dialog>
    );
}
